import React, { Component } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import "./ContentEditable.scss";

class ContentEditable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
      placehoder: props.placeholder || '',
      isDisabled: true
    };

    this.contentRef = React.createRef();
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  onSaveChange = e => {
    e.stopPropagation();
    this.props.onChange(this.state.value.trim());
    this.setState({ isDisabled: true, value: this.props.value.trim() || '' });
  }

  onClickCancel = e => {
    e.stopPropagation();
    this.setState({ isDisabled: true, value: this.props.value || '' });
  }

  onClickEditing = e => {
    if (this.props.editable) {
      this.setState({ isDisabled: false }, () => {
        this.contentRef.current.focus();
      });
    }
  }

  render() {
    const { isDisabled } = this.state;

    return (
      <div className={`editable-content${isDisabled ? '' : ' editing'}`} onClick={this.onClickEditing}>
        <InputGroup>
          {isDisabled && (
            <div className={`disabled-wrapper${!this.state.value ? ' placeholder' : ''}`}>
              {this.state.value ? this.state.value.trim() : this.state.placehoder}
            </div>
          )}
          {!isDisabled && (
            <FormControl
              placeholder={this.state.placehoder}
              aria-label="Description"
              as="textarea"
              rows="5"
              aria-describedby="basic-addon1"
              value={this.state.value}
              onChange={(e) => this.setState({ value: e.target.value && e.target.value !== '' ? e.target.value : '' })}
              disabled={isDisabled}
              ref={this.contentRef}
            />
          )}
        </InputGroup>
        {!isDisabled && <div className="editor-actions">
          <div className="editor-button mr-1" onClick={this.onSaveChange}>
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="editor-button" onClick={this.onClickCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>
        }
      </div>
    );
  }
}

export default ContentEditable;
